module.exports = __webpack_public_path__ + "img/ic_markets_normal.b9c13133.svg";